<div class="form-container service-form ms-large-t" #formContainer>
  <form
    *ngIf="reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR)"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <div class="flex columns form-subgroup">
      <fcom-text-input
        class="full-width"
        [parentForm]="reactiveForm"
        [controlName]="'lastName'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.caseAttachmentsForm.lastName.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.caseAttachmentsForm.lastName'"
      ></fcom-text-input>
      <fcom-text-input
        class="full-width"
        [parentForm]="reactiveForm"
        [controlName]="'caseNumber'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.caseAttachmentsForm.caseNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.caseAttachmentsForm.caseNumber'"
      ></fcom-text-input>
    </div>
    <div class="flex flex--row">
      <fcom-file-uploader
        class="flex-1 mr-medium-b"
        [allowedFileTypes]="allowedFileTypes"
        [controlName]="'file'"
        [i18n]="'SERVICE_FORMS.serviceForms.fields.fileUploader' | finLocalization"
        [id]="'caseAttachmentFile'"
        [maxAttachments]="maxAttachments"
        [maxSizeInBytes]="maxSizeInBytes"
        [parentForm]="reactiveForm"
        #fileUploader
      ></fcom-file-uploader>
    </div>
    <div class="flex flex--row flex--wrap">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
      ></fcom-button>
    </div>
    <div class="flex flex--row flex--wrap">
      <fcom-notification
        *ngIf="formStatus === FormStatus.ERROR"
        class="mr-medium-b"
        [layout]="NotificationLayout.BLOCK"
        [theme]="NotificationTheme.ALERT"
      >
        {{ 'SERVICE_FORMS.serviceForms.error.title' | finLocalization }}
      </fcom-notification>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader align-center">
    <p>{{ 'SERVICE_FORMS.serviceForms.loading.title' | finLocalization }}</p>
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <div *ngIf="formStatus === FormStatus.COMPLETE" class="success-message">
    <h2>{{ 'SERVICE_FORMS.serviceForms.success.title' | finLocalization }}</h2>
  </div>
</div>
